import { Text, Title } from '@common/ui'
import PayloadEditor from './PayloadEditor'

export const AssetSourceView = ({ content, isLoading }: { content: string | undefined; isLoading: boolean }) => (
  <>
    <Title order={4} style={{ flexShrink: 0 }}>
      Payload
    </Title>
    {isLoading ? (
      <Text size="sm" c="dimmed">
        Loading...
      </Text>
    ) : (
      <PayloadEditor value={content} editable={false} />
    )}
  </>
)
